import { useState, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import BTDialogBox from "../../components/BTDialgBox";
import BTBox from "../../components/BTBox";
import BTTypography from "../../components/BTTypography";
import BTInput from "../../components/BTInput";
import EnhancedTable from "../../components/BTTable";
import secureLocalStorage from "react-secure-storage";
import {
  Grid2 as Grid,
  FormControlLabel,
  Switch,
  Autocomplete,
  TextField,
  IconButton,
  Tooltip,
  CircularProgress,
} from "@mui/material";
import { Delete, AddCircle, Notifications } from "@mui/icons-material";
import moment from "moment";
import authService from "../../services/auth-service";
import { batchUpdate } from "../../store/labSlice";
import { useNotification } from "../../context";
const AddCreditnote = ({ open, setOpen, type, todayRate }) => {
  const { u_id, u_type, admin_u_id } = secureLocalStorage.getItem("userdata");
  const { actionType, values } = open?.open_credit;
  const dispatch = useDispatch();
  const { addNotification } = useNotification();
  const initialState = {
    p_id: null,
    admin_u_id: u_type === 1 ? u_id : admin_u_id,
    ser_id: null,
    ser_name: null,
    ser_price_type: null,
    size_id: null,
    p_org_name: null,
    p_org_address_line1: null,
    p_org_address_line2: null,
    p_org_pincode: null,
    p_org_mo_no_1: null,
    p_org_mo_no_2: null,
    p_org_email: null,
    p_org_gst: null,
    p_address: null,
    p_org_state: null,
    cn_prefix: null,
    cn_date: moment().format("YYYY-MM-DD"),
    cn_invoice: null,
    cn_cts: null,
    cn_pcs: null,
    cn_rate: null,
    cn_total: null,
    cn_amount: null,
    cn_type: 1,
    cn_status: null,
    p_cn_id: null,
    cn_desc: null,
    cn_deleted: null,
    sub_cn_lines: [
      {
        p_id: null,
        admin_u_id: u_type === 1 ? u_id : admin_u_id,
        ser_id: null,
        ser_name: null,
        ser_price_type: null,
        size_id: null,
        p_org_name: null,
        p_org_address_line1: null,
        p_org_address_line2: null,
        p_org_pincode: null,
        p_org_mo_no_1: null,
        p_org_mo_no_2: null,
        p_org_email: null,
        p_org_gst: null,
        p_org_state: null,
        p_address: null,
        cn_prefix: null,
        cn_date: moment().format("YYYY-MM-DD"),
        cn_invoice: null,
        cn_cts: null,
        cn_pcs: null,
        cn_rate: null,
        cn_total: null,
        cn_amount: null,
        cn_type: 2,
        cn_status: null,
        p_cn_id: null,
        cn_desc: null,
        cn_deleted: null,
      },
    ],
  };
  const [formValues, setFormValues] = useState(
    actionType === 1 ? initialState : values
  );
  const [errors, setErrors] = useState({});
  const [editableRate, setEditableRate] = useState(todayRate);
  const [loading, setLoading] = useState(false);
  const [isConfirmed, setConfirm] = useState(false);
  const parties = useSelector((state) => state?.lab?.parties);
  const sizes = useSelector((state) => state?.lab?.sizes);
  const selectedPartyAliases =
    parties?.data?.find((party) => party.p_id === formValues.p_id)?.p_allias ||
    [];
  const selectedCompany =
    selectedPartyAliases.find(
      (alias) => alias.p_org_name === formValues.p_org_name
    ) || null;
  const selectedParty = parties?.data?.find(
    ({ p_id }) => p_id === formValues?.p_id
  );
  const handleClose = () => {

    setOpen((prev) => ({
      ...prev,
      open_credit: null,
    }));
  };
  const handlePartySelect = (event, selectedParty) => {
    clearError("p_id");
    if (selectedParty) {
      // Update main form values and sub_cn_lines with selected party's p_id
      setFormValues((prev) => ({
        ...prev,
        p_id: selectedParty.p_id,
        p_org_name: selectedParty.p_org_name || null,
        p_org_address_line1: selectedParty.p_org_address_line1 || null,
        p_org_address_line2: selectedParty.p_org_address_line2 || null,
        p_org_pincode: selectedParty.p_org_pincode || null,
        p_org_mo_no_1: selectedParty.p_org_mo_no_1 || null,
        p_org_mo_no_2: selectedParty.p_org_mo_no_2 || null,
        p_org_email: selectedParty.p_org_email || null,
        p_org_gst: selectedParty.p_org_gst || null,
        p_address: selectedParty.p_address || null,
        p_org_state: selectedParty.p_org_state || null,
        // Update sub_cn_lines with the same p_id
        sub_cn_lines: prev.sub_cn_lines.map((line) => ({
          ...line,
          p_id: selectedParty.p_id,
          p_org_name: selectedParty.p_org_name || null,
          p_org_address_line1: selectedParty.p_org_address_line1 || null,
          p_org_address_line2: selectedParty.p_org_address_line2 || null,
          p_org_pincode: selectedParty.p_org_pincode || null,
          p_org_mo_no_1: selectedParty.p_org_mo_no_1 || null,
          p_org_mo_no_2: selectedParty.p_org_mo_no_2 || null,
          p_org_email: selectedParty.p_org_email || null,
          p_org_gst: selectedParty.p_org_gst || null,
          p_address: selectedParty.p_address || null,
          p_org_state: selectedParty.p_org_state || null,
        })),
      }));
    } else {
      // Reset to initial state when no party is selected
      setFormValues(initialState);
    }
  };

  const handleCompanySelect = (event, selectedCompany) => {
    // Get the selected party to access p_address
    const selectedParty = parties?.data?.find(
      (party) => party.p_id === formValues.p_id
    );
    const hasSelectedCompany =
      selectedCompany && Object.keys(selectedCompany).length > 0;
    setFormValues((prev) => {
      // Check if selectedCompany exists

      return {
        ...prev,
        p_org_name: hasSelectedCompany
          ? selectedCompany.p_org_name
          : selectedParty.p_org_name,
        p_org_address_line1: hasSelectedCompany
          ? selectedCompany.p_org_address_line1
          : selectedParty.p_org_address_line1,
        p_org_address_line2: hasSelectedCompany
          ? selectedCompany.p_org_address_line2
          : selectedParty.p_org_address_line2,
        p_org_pincode: hasSelectedCompany
          ? selectedCompany.p_org_pincode
          : selectedParty.p_org_pincode,
        p_org_gst: hasSelectedCompany
          ? selectedCompany.p_org_gst
          : selectedParty.p_org_gst,
        p_org_mo_no_1: hasSelectedCompany
          ? selectedCompany.p_org_mo_no_1
          : selectedParty.p_org_mo_no_1,
        p_org_mo_no_2: hasSelectedCompany
          ? selectedCompany.p_org_mo_no_2
          : selectedParty.p_org_mo_no_2,
        p_org_email: hasSelectedCompany
          ? selectedCompany.p_org_email
          : selectedParty.p_org_email,
        p_org_state: hasSelectedCompany
          ? selectedCompany.p_org_state
          : selectedParty.p_org_state,
        sub_cn_lines: prev.sub_cn_lines.map((line) => ({
          ...line,
          p_org_name: hasSelectedCompany
            ? selectedCompany.p_org_name
            : selectedParty.p_org_name,
          p_org_address_line1: hasSelectedCompany
            ? selectedCompany.p_org_address_line1
            : selectedParty.p_org_address_line1,
          p_org_address_line2: hasSelectedCompany
            ? selectedCompany.p_org_address_line2
            : selectedParty.p_org_address_line2,
          p_org_pincode: hasSelectedCompany
            ? selectedCompany.p_org_pincode
            : selectedParty.p_org_pincode,
          p_org_gst: hasSelectedCompany
            ? selectedCompany.p_org_gst
            : selectedParty.p_org_gst,
          p_org_mo_no_1: hasSelectedCompany
            ? selectedCompany.p_org_mo_no_1
            : selectedParty.p_org_mo_no_1,
          p_org_mo_no_2: hasSelectedCompany
            ? selectedCompany.p_org_mo_no_2
            : selectedParty.p_org_mo_no_2,
          p_org_email: hasSelectedCompany
            ? selectedCompany.p_org_email
            : selectedParty.p_org_email,
        })),
      };
    });
  };

  const handleDateChange = (e) => {
    const dateValue = e.target.value; // This will be in YYYY-MM-DDTHH:mm format

    setFormValues((prev) => ({
      ...prev,
      cn_date: moment(dateValue).format("YYYY-MM-DD"),
      sub_cn_lines: prev.sub_cn_lines.map((line) => ({
        ...line,
        cn_date: moment(dateValue).format("YYYY-MM-DD"),
      })),
    }));
  };

  const handleInvoiceChange = (e) => {
    const invoiceValue = e.target.value;

    setFormValues((prev) => ({
      ...prev,
      cn_invoice: invoiceValue || null,

      // Update invoice in all sub_cn_lines
      sub_cn_lines: prev.sub_cn_lines.map((line) => ({
        ...line,
        cn_invoice: invoiceValue || null,
      })),
    }));
  };
  const validateForm = () => {
    const newErrors = {};
    const lineErrors = [];
    if (isNaN(parseFloat(editableRate))) {
      newErrors.cnv_rate = "Amount must be a valid number";
    } else if (parseFloat(editableRate) <= 0) {
      newErrors.cnv_rate = "Amount must be greater than 0";
    }
    if (!formValues.p_id) {
      newErrors.p_id = "Please select a party";
    }
    formValues.sub_cn_lines.forEach((line, index) => {
      const lineError = {};
      if (!line.cn_amount || line.cn_amount === "") {
        lineError.cn_amount = "Amount is required";
      } else if (isNaN(parseFloat(line.cn_amount))) {
        lineError.cn_amount = "Amount must be a valid number";
      } else if (parseFloat(line.cn_amount) <= 0) {
        lineError.cn_amount = "Amount must be greater than 0";
      }
      // Validate description - required field
      if (!line.cn_desc || line.cn_desc.trim() === "") {
        lineError.cn_desc = "Description is required";
      }

      if (Object.keys(lineError).length > 0) {
        lineErrors[index] = lineError;
      }
    });
    if (lineErrors.length > 0) {
      newErrors.sub_cn_lines = lineErrors;
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const clearError = (fieldName, index = null) => {
    setErrors((prev) => {
      const newErrors = { ...prev };

      if (index !== null && newErrors.sub_cn_lines) {
        // Clear line-specific error
        const lineErrors = [...newErrors.sub_cn_lines];
        if (lineErrors[index] && lineErrors[index][fieldName]) {
          delete lineErrors[index][fieldName];
          if (Object.keys(lineErrors[index]).length === 0) {
            delete lineErrors[index];
          }
          newErrors.sub_cn_lines = lineErrors;
        }

        // Remove sub_cn_lines key if empty
        if (
          newErrors.sub_cn_lines &&
          Object.keys(newErrors.sub_cn_lines).length === 0
        ) {
          delete newErrors.sub_cn_lines;
        }
      } else {
        // Clear main form error
        delete newErrors[fieldName];
      }
      return newErrors;
    });
  };
  const handleAddLine = () => {
    setFormValues((prev) => ({
      ...prev,
      sub_cn_lines: [
        ...prev.sub_cn_lines,
        {
          p_id: prev.p_id,
          admin_u_id: u_type === 1 ? u_id : admin_u_id,
          ser_id: null,
          ser_name: null,
          ser_price_type: null,
          size_id: null,
          p_org_name: prev.p_org_name,
          p_org_address_line1: prev.p_org_address_line1,
          p_org_address_line2: prev.p_org_address_line2,
          p_org_pincode: prev.p_org_pincode,
          p_org_mo_no_1: prev.p_org_mo_no_1,
          p_org_mo_no_2: prev.p_org_mo_no_2,
          p_org_email: prev.p_org_email,
          p_org_gst: prev.p_org_gst,
          p_org_state: prev.p_org_state,
          p_address: prev.p_address,
          cn_prefix: prev.cn_prefix,
          cn_date: prev.cn_date,
          cn_invoice: prev.cn_invoice,
          cn_cts: null,
          cn_pcs: null,
          cn_rate: null,
          cn_total: null,
          cn_amount: null,
          cn_type: 2,
          cn_status: null,
          p_cn_id: null,
          cn_desc: null,
          cn_deleted: null,
        },
      ],
    }));
  };

  // Function to delete a line
  const handleDeleteLine = (index) => {
    setFormValues((prev) => ({
      ...prev,
      sub_cn_lines: prev.sub_cn_lines.filter((_, i) => i !== index),
    }));
  };
  const handleTableFieldChange = (fieldName, value, index) => {
    if (fieldName === "cn_amount" || fieldName === "cn_desc") {
      clearError(fieldName, index);
    }
    setFormValues((prev) => {
      const updatedLines = [...prev.sub_cn_lines];
      updatedLines[index] = {
        ...updatedLines[index],
        [fieldName]: value,
      };

      return {
        ...prev,
        sub_cn_lines: updatedLines,
      };
    });
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      addNotification({
        title: "Validation Error",
        message: "Please fix the errors in the form",
        type: "error",
        color: "error",
        icon: <Notifications fontSize="small" color="white" />,
      });
      return;
    }
    const finalFormData = {
      ...formValues,
      cn_status: isConfirmed ? 2 : 1,
      cn_amount: formValues?.sub_cn_lines?.reduce(
        (total, item) => total + Number(item?.cn_amount),
        0
      ),
      cn_total: formValues?.sub_cn_lines?.reduce(
        (total, item) => total + Number(item?.cn_total),
        0
      ),
      sub_cn_lines: formValues?.sub_cn_lines?.map((item) => ({
        ...item,
        cn_status: isConfirmed ? 2 : 1,
      })),
    };
    try {
      setLoading(true);
      const isNewRec = !formValues?.cn_id ? true : false;
      const response = isNewRec
        ? await authService?.insert_credit_note({ attributes: finalFormData })
        : await authService?.update_credit_note({ attributes: finalFormData });
      if (response?.status === 1) {
        const { sub_cn_lines, ...data } = response?.data;
        const updateRec = type ? sub_cn_lines : [data];

        dispatch(
          batchUpdate({
            name: "creditnote",
            key: "cn_id",
            insert: [],
            updateItems: updateRec,
            removeItems: [],
          })
        );

        addNotification({
          title: "Successfully",
          message: response?.message,
          type: "success",
          color: "success",
          icon: <Notifications fontSize="small" color="white" />,
        });
        handleClose();
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };
  const handleRateChange = (newRate) => {
    clearError("cnv_rate");
    setEditableRate(newRate);
    setFormValues((prevData) => {
      if (!prevData?.sub_cn_lines) return prevData;

      const updatedLines = prevData.sub_cn_lines.map((line) => ({
        ...line,
        cn_total: line.cn_amount * Number(newRate),
      }));

      const cn_total = updatedLines.reduce(
        (total, item) => total + Number(item?.cn_total),
        0
      );

      return {
        ...prevData,
        sub_cn_lines: updatedLines,
        cn_total: cn_total?.toFixed(2),
      };
    });
  };
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "service",
      name: "Service",
      selector: (row) => row.ser_name || "-",
    },
    {
      id: "size",
      name: "Size",
      selector: (row) => {
        return "-";
      },
    },
    {
      id: "pcs",
      name: "Pcs",
      selector: (row, index) => "-",
    },
    {
      id: "weight",
      name: "Weight",
      selector: (row, index) => "-",
    },
    {
      id: "rate",
      name: "Rate",
      selector: (row, index) => "-",
    },
    {
      id: "amount",
      name: "Amount($)",
      selector: (row, index) => (
        <BTInput
          value={row?.cn_amount || ""}
          variant="standard"
          onChange={(e) => {
            handleTableFieldChange("cn_amount", e.target.value, index);
            handleTableFieldChange(
              "cn_total",
              Number(e.target.value * editableRate),
              index
            );
          }}
          type="number"
          size="small"
          error={errors.sub_cn_lines && errors.sub_cn_lines[index]?.cn_amount}
          helperText={
            errors.sub_cn_lines && errors.sub_cn_lines[index]?.cn_amount
          }
          fullWidth
        />
      ),
    },
    {
      id: "total",
      name: "Total",
      selector: (row) => row?.cn_total || "-",
    },
    {
      id: "cn_desc",
      name: "Description",
      selector: (row, index) => (
        <BTInput
          value={row?.cn_desc || ""}
          variant="standard"
          onChange={(e) => {
            handleTableFieldChange("cn_desc", e.target.value, index);
          }}
          type="text"
          size="small"
          error={errors.sub_cn_lines && errors.sub_cn_lines[index]?.cn_desc}
          helperText={
            errors.sub_cn_lines && errors.sub_cn_lines[index]?.cn_desc
          }
          fullWidth
        />
      ),
    },
    {
      id: "actions",
      name: "Actions",
      selector: (row, index) => (
        <BTBox sx={{ display: "flex", gap: 1 }}>
          {!row?.cn_id && (
            <Tooltip title="Delete Line">
              <IconButton
                size="small"
                color="error"
                onClick={() => handleDeleteLine(index)}
                disabled={formValues.sub_cn_lines.length === 1}
              >
                <Delete fontSize="small" />
              </IconButton>
            </Tooltip>
          )}

          {index === formValues.sub_cn_lines.length - 1 && (
            <Tooltip title="Add Line">
              <IconButton size="small" color="primary" onClick={handleAddLine}>
                <AddCircle fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </BTBox>
      ),
      width: "120px",
    },
  ];

  return (
    <BTDialogBox
      open={Boolean(open)}
      fullWidth
      maxWidth="xl"
      maxHeight="500px"
      minHeight="500px"
      title="Credit Notes"
      close={handleClose}
      onSubmit={onSubmit}
      buttons={[
        {
          name: "Cancel",
          color: "secondary",
          size: "small",
          onClick: handleClose,
        },
        {
          name: isConfirmed ? "Confirm" : "Edit",
          variant: "gradient",
          type: "submit",
          color: "dark",
          size: "small",
          loading: loading,
          loadingComponent: (
            <Fragment>
              <svg width={0} height={0}>
                <defs>
                  <linearGradient
                    id="my_gradient"
                    x1="0%"
                    y1="0%"
                    x2="0%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#e01cd5" />
                    <stop offset="100%" stopColor="#1CB5E0" />
                  </linearGradient>
                </defs>
              </svg>
              <CircularProgress
                size={22}
                sx={{
                  "svg circle": { stroke: "url(#my_gradient)" },
                }}
              />
            </Fragment>
          ),
          sx: { ml: 2, width: "80px" },
          disabled: loading,
        },
      ]}
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, md: 12 }}>
          <BTBox
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexDirection: { xs: "column", md: "row" },
              alignItems: { xs: "flex-start", md: "center" },
              justifyContent: "space-between", // Fixed the typo here
            }}
          >
            <BTBox
              mt={2}
              sx={{
                width: "100%", // Full width on mobile, auto on desktop
              }}
            >
              <FormControlLabel
                labelPlacement="end"
                control={
                  <Switch
                    value={isConfirmed}
                    size="small"
                    color="secondary"
                    onChange={(e) => {
                      setConfirm(e.target.checked);
                    }}
                  />
                }
                label={"Confirmed"}
                sx={{
                  width: "auto",
                  m: 0,
                  "& .MuiFormControlLabel-label": {
                    minWidth: "fit-content",
                  },
                }}
              />
            </BTBox>
            <BTBox
              sx={{
                width: "100%",
              }}
            >
              <Autocomplete
                sx={{ width: "100%" }}
                options={parties?.data}
                getOptionLabel={(option) => option?.p_name}
                getOptionKey={(option) => option?.p_id}
                onChange={handlePartySelect}
                value={
                  parties?.data?.find(
                    (party) => party.p_id === formValues.p_id
                  ) || null
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select Party"
                    variant="standard"
                    sx={{ width: "100%" }}
                    error={!!errors.p_id}
                    helperText={errors.p_id}
                  />
                )}
              />
            </BTBox>
            <BTBox
              sx={{
                width: "100%", // Full width on mobile, auto on desktop
              }}
            >
              <Autocomplete
                sx={{ width: "100%" }}
                options={selectedPartyAliases}
                getOptionLabel={(option) => option?.p_org_name || ""}
                value={selectedCompany}
                onChange={handleCompanySelect}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Select company"
                    variant="standard"
                    sx={{ width: "100%" }}
                  />
                )}
              />
            </BTBox>

            <BTBox
              sx={{
                width: "100%", // Full width on mobile, fixed width on desktop
              }}
            >
              <BTTypography variant="caption" fontWeight="bold">
                Conversion Rate:
              </BTTypography>
              <BTInput
                value={editableRate}
                variant="standard"
                onChange={(e) => handleRateChange(e.target.value)}
                type="number"
                fullWidth
                size="small"
                error={!!errors.cnv_rate}
                helperText={errors.cnv_rate}
              />
            </BTBox>

            <BTBox
              sx={{
                width: "100%", // Full width on mobile, auto on desktop
              }}
            >
              <BTTypography variant="caption" fontWeight="bold">
                Invoice
              </BTTypography>
              <BTInput
                fullWidth
                size="small"
                variant="standard"
                value={formValues?.cn_invoice || ""}
                onChange={handleInvoiceChange}
              />
            </BTBox>

            <BTBox
              sx={{
                width: "100%", // Full width on mobile, auto on desktop
              }}
            >
              <BTTypography variant="caption" fontWeight="bold">
                Date
              </BTTypography>
              <BTInput
                fullWidth
                size="small"
                type="datetime-local"
                variant="standard"
                value={
                  moment(formValues?.cn_date, "YYYY-MM-DD").format(
                    "YYYY-MM-DD HH:mm:ss"
                  ) || ""
                }
                onChange={handleDateChange}
              />
            </BTBox>
          </BTBox>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <BTBox
            sx={{
              p: 1,
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              maxHeight: 300,
              overflow: "auto",
            }}
          >
            <BTTypography variant="subtitle2" gutterBottom>
              Party Information
            </BTTypography>

            <Grid container>
              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Party Name:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {selectedParty?.p_name}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Party Address:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {selectedParty?.p_address}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Party Mo. No.:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {selectedParty?.p_mo_no}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Party Email:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {selectedParty?.p_email}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Party GST #:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {selectedParty?.p_org_gst}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </BTBox>
        </Grid>
        <Grid size={{ xs: 12, md: 4 }}>
          <BTBox
            sx={{
              p: 1,
              border: "1px solid #e0e0e0",
              borderRadius: 1,
              maxHeight: 300,
              overflow: "auto",
            }}
          >
            <BTTypography variant="subtitle2" gutterBottom>
              Company Information
            </BTTypography>
            <Grid container>
              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Company Name:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {formValues?.p_org_name}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Address 1:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {formValues?.p_org_address_line1}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Address 2:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {formValues?.p_org_address_line2}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Pin code:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {formValues?.p_org_pincode}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid size={{ xs: 12 }}>
                <Grid container>
                  <Grid size={{ xs: 5 }}>
                    <BTTypography variant="caption" fontWeight="bold">
                      Company GST#:
                    </BTTypography>
                  </Grid>
                  <Grid size={{ xs: 7 }}>
                    <BTTypography variant="caption" noWrap>
                      {formValues?.p_org_gst}
                    </BTTypography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </BTBox>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <BTBox
            sx={{
              width: "100%",
              overflow: "auto",
              maxHeight: 400,
            }}
          >
            <EnhancedTable
              columns={columns}
              rows={formValues?.sub_cn_lines || []}
              tableHeader={false}
            />
          </BTBox>
        </Grid>
      </Grid>
    </BTDialogBox>
  );
};
export default AddCreditnote;
